import { TableField } from "../table-field";

export const tableFieldsMeusRecibos: TableField[] = [
    {
        key: 'NrProtocolo',
        label: 'Nr Protocolo',
        tdClass: "align-middle",
        thClass: "text-center",
        sortable: true,
    },
    {
        key: "Assunto",
        label: "Assunto",
        tdClass: "align-middle mw-25",
        thClass: "align-center",
        sortable: true,
    },
    {
        key: "DtProtocolo",
        label: "Data",
        tdClass: "align-middle",
        thClass: "align-center",
        sortable: true,
    },
    {
        key: "QtdPecas",
        label: "Qtd de Peças",
        tdClass: "align-middle",
        thClass: "align-center",
        sortable: true,
    },
    {
        key: "actions",
        label: "Ações",
        tdClass: ["align-middle", "col-actions"],
        thClass: "text-center",
        sortable: false,
    }
]